const aboutContentParagraph = document.querySelectorAll("#about-text p");
const visionContentParagraph = document.querySelectorAll("#vision-mission .card-text");
const ourcareInfoTextContentParagraph = document.querySelectorAll("#our-care .info-text");
const ourcareContentParagraph = document.querySelectorAll("#our-care .card-text");
const qualityContentParagraph = document.querySelectorAll("#quality .info-text");

function replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(10), "g");
    return str.trim().replace(re, "<br>");
}

aboutContentParagraph.forEach( (paragraph) => {
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});

visionContentParagraph.forEach( (paragraph) => {
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});

ourcareInfoTextContentParagraph.forEach( (paragraph) => {
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});

ourcareContentParagraph.forEach( (paragraph) => {
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});

qualityContentParagraph.forEach( (paragraph) => {
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});
